// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"
import { logger } from "../logger"

// Get ActionCable URL from meta tag or construct from current location
function getActionCableURL() {
  // Try to read from meta tag first (set by action_cable_meta_tag helper)
  const metaTag = document.querySelector('meta[name="action-cable-url"]')
  if (metaTag && metaTag.content) {
    logger.log('[ActionCable] Using URL from meta tag:', metaTag.content)
    return metaTag.content
  }
  
  // Fallback: construct from current page URL
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const host = window.location.host
  const url = `${protocol}//${host}/cable`
  logger.warn('[ActionCable] Meta tag not found, using fallback URL:', url)
  return url
}

const cableURL = getActionCableURL()
logger.log('[ActionCable] Creating consumer with URL:', cableURL)

const consumer = createConsumer(cableURL)

export default consumer
